// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__2MG6W","clinicsSelect":"TableHeading_clinicsSelect__1I9SH"};